// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"5046":"vendors.excalidraw","7650":"vendors.lexical"}[chunkId] || chunkId) + "." + {"2698":"2bf5fd68723465f4f84c","5046":"2fee9527458c5e584988","5160":"eeef2e315c612c217c69","5603":"f921debe72dad5dc26f9","7650":"31978469bb6cdc4e80d2"}[chunkId] + ".min.js";
};